(() => {
  'use strict';
  if (window.bhbVinSearchInstalled) return;
  window.bhbVinSearchInstalled = true;
  const resultStyle=document.createElement('style');
  resultStyle.textContent='#content .shopify-section[id]:has([vid="vindecode"] [vid="vin-results"][style*="display: block"]){z-index:5!important}';
  document.head.append(resultStyle);
  const LIMIT = 5;
  const states = new WeakMap();
  const history = [];
  const productCache = new Map();
  window.vindecode_adv_input = {
    ElectrificationLevel: {label:'Electrification Level',show:false},
    FuelTypePrimary: {label:'Primary Fuel Type',show:false},
    FuelTypeSecondary: {label:'Secondary Fuel Type',show:false},
    Note: {label:'Vehicle Note',show:false},
    Trim: {label:'Trim',show:false}
  };
  const handles = {
    prius1:'toyota-prius-2001-2003-hybrid-battery',
    prius2:'toyota-prius-2004-2009-hybrid-battery',
    prius3:'toyota-prius-hybrid-battery-2010-2015',
    priusNi:'2016-2019-toyota-prius-li-hybrid-battery',
    priusLi:'toyota-prius-2016-2019-hybrid-battery-lithium',
    priusPlugin:'2012-16-toyota-prius-plug-in-hybrid-battery',
    priusPrime:'tppig2',
    priusC:'toyota-prius-c-2012-2016-hybrid-battery',
    priusV:'toyota-prius-v-hybrid-battery-2012-2018',
    fusion1:'fusion-2010-2012-hybrid-battery',
    fusion2:'fusion-2013-2015',
    fusion3:'fusion-2016-2019',
    fusionEnergi:'ffeg1',
    cmax:'ford-c-max-2013-2018-hybrid-battery',
    cmaxEnergi:'ford-c-max-energi-2013-2017-plug-in-hybrid-battery',
    camryNi:'hybrid-battery-for-toyota-camry-2018-2024',
    camryLi:'toyota-camry-2018-2024-hybrid-battery-lithium',
    sonata:'hyundai-sonata-hybrid-battery-2016-2019',
    sonataPlugin:'hyundai-sonata-2016-2018-plug-in-hybrid-battery',
    optima2:'kia-optima-2013-2015-hybrid-battery',
    optima3:'kia-optima-2016-2019-hybrid-battery',
    optimaPlugin:'kia-optima-plug-in-2016-2019-hybrid-battery',
    niro:'kia-niro-2017-2019-hybrid-battery',
    niroPlugin:'kia-niro-2017-2019-hybrid-battery-plug-in',
    ioniq:'hyundai-ioniq-2017-2022-hybrid-battery',
    ioniqPlugin:'hyundai-ioniq-plug-in-2018-2022-hybrid-battery'
  };
  const upper = value => String(value || '').trim().toUpperCase();
  function vehicle(detail) {
    const data = {...detail.vehicleData,...detail.primaryData,...detail.secondaryData,...detail.customData};
    const make = upper(data.Make), model = upper(data.Model), vin = upper(detail.vin);
    const electrical = upper(data.ElectrificationLevel);
    const phev = /PHEV|PLUG[ -]?IN/.test(electrical+' '+upper(data.Note)+' '+upper(data.Trim));
    const ev = !phev && (/\b(?:BEV|EV|FCEV)\b/.test(electrical) || (upper(data.FuelTypePrimary)==='ELECTRIC' && !upper(data.FuelTypeSecondary)));
    const hev = !phev && !ev && (/HEV|HYBRID/.test(electrical) || upper(data.FuelTypeSecondary)==='ELECTRIC' || upper(data.FuelTypePrimary)==='ELECTRIC');
    return {vin,make,model,year:Number(data.ModelYear)||0,phev,ev,hev,data};
  }
  function route(v) {
    const k=v.vin.slice(6,8), inYears=(a,b)=>v.year>=a&&v.year<=b;
    let key='', rule='decoded_model_year', tag=v.phev?'Plug-In':v.ev?'EV':'';
    if(v.make==='TOYOTA' && /^PRIUS(?:\b|$)/.test(v.model)) {
      if(inYears(2001,2003)){key='prius1';rule='prius_2001_2003';}
      else if(inYears(2004,2009)){key='prius2';rule='prius_2004_2009';}
      else if(k==='DP' || (v.phev&&inYears(2012,2016))){key='priusPlugin';rule='prius_plugin';tag='Plug-In';}
      else if(v.model==='PRIUS C'||k==='B3'){key='priusC';rule='prius_c';}
      else if(v.model==='PRIUS V'||k==='EU'){key='priusV';rule='prius_v';}
      else if(v.phev&&inYears(2017,2022)){key='priusPrime';rule='prius_prime';tag='Prime';}
      else if(k==='FU'&&inYears(2016,2019)){
        key=({'A':'priusLi','B':'priusNi','9':'priusNi'})[v.vin[4]]||'';
        rule=key?'prius_fu_'+v.vin[4]:'prius_fu_unresolved';
      } else if(inYears(2010,2015)){key='prius3';rule='prius_2010_2015';}
    } else if(v.make==='FORD' && v.model==='FUSION') {
      tag=v.phev?'Energi':'Hybrid';
      if(v.phev||v.vin[6]==='P'||k==='PH'){key='fusionEnergi';rule='fusion_energi';}
      else if(k==='LU'&&v.vin[9]==='G'){key='fusion3';rule='fusion_lu_g';}
      else if(inYears(2010,2012)){key='fusion1';rule='fusion_2010_2012';}
      else if(inYears(2013,2015)){key='fusion2';rule='fusion_2013_2015';}
      else if(inYears(2016,2020)){key='fusion3';rule='fusion_2016_2020';}
    } else if(v.make==='FORD' && v.model.replace(/[^A-Z]/g,'')==='CMAX') {
      key=v.phev||v.vin.slice(3,7)==='DP5C'?'cmaxEnergi':'cmax';rule=key;tag=key==='cmaxEnergi'?'Energi':'Hybrid';
    } else if(v.make==='TOYOTA' && v.model==='CAMRY' && inYears(2018,2024)) {
      key=({'2':'camryNi','3':'camryLi'})[v.vin[4]]||'';rule=key||'camry_unresolved';
    } else if(v.make==='HYUNDAI' && v.model==='SONATA' && inYears(2016,2019)) {
      key=v.phev||['1','5'].includes(v.vin[4])?'sonataPlugin':'sonata';rule=key;
    } else if(v.make==='KIA' && v.model==='OPTIMA') {
      if(v.vin.startsWith('KNAGM4AD')||inYears(2013,2016)){key='optima2';rule='optima_2013_2016';}
      else if(inYears(2017,2019)){key=v.phev||v.vin[5]==='V'?'optimaPlugin':'optima3';rule=key;}
    } else if(v.make==='KIA' && v.model==='NIRO') {
      key=v.phev||v.vin[7]==='D'?'niroPlugin':'niro';rule=key;tag=key==='niroPlugin'?'Plug In':'Hybrid';
    } else if(v.make==='HYUNDAI' && v.model==='IONIQ') {
      key=v.phev||v.vin[7]==='D'?'ioniqPlugin':'ioniq';rule=key;
    } else if(v.make==='TOYOTA' && v.phev){tag='Prime';}
    else if(v.make==='VOLVO' && v.phev){tag='Recharge';}
    else if(v.make==='PORSCHE' && v.phev){tag='E-Hybrid';}
    else if(v.make==='TOYOTA' && v.model==='HIGHLANDER'){tag='Hybrid';}
    return {handle:handles[key]||'',rule,query:[v.make,v.year||'',v.model,tag].filter(Boolean).join(' ')};
  }
  function ranges(text) {
    return Array.from(String(text).matchAll(/\b(19\d{2}|20\d{2})\s*(?:[-–—~]|to)\s*(19\d{2}|20\d{2})\b/gi),m=>[Number(m[1]),Number(m[2])]);
  }
  function candidateHandle(p) {
    if(p.handle) return p.handle;
    try { return new URL(p.url,location.origin).pathname.split('/products/')[1]?.split('/')[0]||''; } catch {return '';}
  }
  function exclusion(p,v,r) {
    const handle=candidateHandle(p), title=upper(p.title), text=title+' '+handle.toUpperCase();
    if(r.handle && handle!==r.handle) return 'Battery rule requires '+r.handle;
    let years=ranges(p.title);
    if(!years.length) years=ranges(handle);
    if(v.year && years.length && !years.some(([a,b])=>v.year>=a&&v.year<=b)) return 'Model year '+v.year+' outside '+years.map(y=>y.join('–')).join(', ');
    if(!r.handle) {
      const modelTokens=v.model.replace(/[^A-Z0-9 ]/g,' ').split(/\s+/).filter(Boolean);
      if(!title.includes(v.make)||!modelTokens.every(token=>title.replace(/[^A-Z0-9 ]/g,' ').includes(token))) return 'Different vehicle family';
      const plugin=/PLUG[ -]?IN|PHEV|ENERGI|PRIME/.test(text);
      if(v.phev&&!plugin) return 'Plug-in battery required';
      if(!v.phev&&plugin) return 'Plug-in battery incompatible';
      if(v.ev&&!/\bEV\b|ELECTRIC VEHICLE/.test(title)) return 'Electric vehicle battery required';
      if(!years.length) return 'No model-year eligibility available';
    }
    return '';
  }
  function rootFor(event) {
    const direct=event.target.closest?.('[vid="vindecode"][svid]');
    if(direct)return direct;
    return Array.from(document.querySelectorAll('[vid="vindecode"][svid]')).find(el=>el.getAttribute('svid')===event.detail?.blockId)||null;
  }
  function basePath(){return window.Shopify?.routes?.root||'/';}
  function output(root,products,v,r,record) {
    const host=root.querySelector('[vid="vin-suggest-results"]');
    if(!host)return;
    host.replaceChildren();
    const container=document.createElement('div');container.id='vfitzplus-predictive-search-results';container.setAttribute('vid','predictive-results');
    const list=document.createElement('ul');list.style.cssText='list-style:none;padding:0;margin:0';
    record.candidates=products.map(p=>({handle:candidateHandle(p),title:p.title,exclusion:exclusion(p,v,r)}));
    const accepted=products.filter(p=>!exclusion(p,v,r)).slice(0,LIMIT);
    record.visible=accepted.map(candidateHandle);
    for(const p of accepted){
      const li=document.createElement('li');li.className='list-item';
      const a=document.createElement('a');a.className='item-link';a.href=basePath()+'products/'+candidateHandle(p);a.style.cssText='display:flex;align-items:center;gap:12px;padding:10px;text-decoration:none';
      const src=p.featured_image?.url||p.featured_image||p.image;
      if(typeof src==='string'&&src){const img=document.createElement('img');img.src=src;img.alt='';img.width=50;img.height=50;img.style.objectFit='contain';a.append(img);}
      const content=document.createElement('div');content.className='item-content';const title=document.createElement('span');title.className='item-heading';title.textContent=p.title;content.append(title);
      const amount=typeof p.price==='number'?p.price/100:Number(p.price);
      if(Number.isFinite(amount)){const price=document.createElement('div');price.className='item-price';price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(amount);content.append(price);}
      a.append(content);li.append(a);list.append(li);
    }
    if(!accepted.length){const message=document.createElement('p');message.textContent=record.error?'Battery search is temporarily unavailable. Please try again or contact us.':'No matching battery found. Please contact us with your VIN.';list.append(message);}
    container.append(list);host.append(container);
    const link=root.querySelector('[vid="vin-shop-search"]');if(link){link.removeAttribute('onclick');link.href=basePath()+'search?q='+encodeURIComponent(r.query)+'&type=product';}
    record.status=record.error?'error':'complete';
    console.info('[BHB VIN] '+JSON.stringify(record));
  }
  async function retrieve(root,state,v,r,record) {
    const current=()=>states.get(root)===state&&upper(root.querySelector('[vid="mc-vin-block-input"]')?.value)===v.vin;
    try {
      const params=new URLSearchParams({q:r.query,'resources[type]':'product','resources[limit]':String(LIMIT),'resources[options][unavailable_products]':'last'});
      const response=await fetch(basePath()+'search/suggest.json?'+params,{signal:state.controller.signal});
      if(!response.ok)throw new Error('Predictive search HTTP '+response.status);
      let products=(await response.json()).resources?.results?.products||[];
      record.predictiveCandidates=products.map(p=>({handle:candidateHandle(p),title:p.title}));
      if(r.handle&&!products.some(p=>candidateHandle(p)===r.handle)){
        let product=productCache.get(r.handle);
        if(!product){const result=await fetch(basePath()+'products/'+encodeURIComponent(r.handle)+'.js',{signal:state.controller.signal});if(!result.ok)throw new Error('Target retrieval HTTP '+result.status);product=await result.json();productCache.set(r.handle,product);}
        if(candidateHandle(product)!==r.handle)throw new Error('Target retrieval returned an unexpected product');
        record.targetRetrieval=r.handle;products=[...products,product];
      }
      if(current())output(root,products,v,r,record);
    } catch(error){if(error.name!=='AbortError'&&current()){record.error=error.message;output(root,[],v,r,record);}}
  }
  document.addEventListener('input',event=>{
    if(!event.target.matches?.('[vid="mc-vin-block-input"]'))return;
    const root=event.target.closest('[vid="vindecode"][svid]');if(!root)return;
    states.get(root)?.controller.abort();states.delete(root);
    root.querySelector('[vid="vin-suggest-results"]')?.replaceChildren();
  },true);
  document.addEventListener('vfitz:vin:decoded',event=>{
    const d=event.detail,root=rootFor(event);if(!d||!root)return;
    event.preventDefault();d.shouldSuggest=false;
    const v=vehicle(d);
    if(v.vin!==upper(root.querySelector('[vid="mc-vin-block-input"]')?.value)||v.vin.length!==17)return;
    states.get(root)?.controller.abort();const state={controller:new AbortController()};states.set(root,state);
    const r=route(v);d.query=r.query;d.searchUrl=basePath()+'search?q='+encodeURIComponent(r.query)+'&type=product';d.matchedRuleId=r.rule;
    const record={timestamp:new Date().toISOString(),page:location.pathname,blockId:d.blockId,vin:v.vin,decoded:v.data,powertrain:{phev:v.phev,hev:v.hev,ev:v.ev},query:r.query,rule:r.rule,target:r.handle,limit:LIMIT,status:'loading'};
    history.push(record);if(history.length>100)history.shift();
    const promise=retrieve(root,state,v,r,record);if(typeof d.waitUntil==='function')d.waitUntil(promise);
  });
  window.bhbVinSearch={vehicle,route,exclusion,history,limit:LIMIT};
})();
